<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row>
          <el-col :span="24">
            <div class="content">
              <div class="title">
                <el-row>
                  <el-col :span="1">
                    <i class="el-icon-warning warn"></i>
                    <!-- <el-button type="warning" icon="el-icon-star-off" circle></el-button> -->
                  </el-col>
                  <el-col :span="23">
                      <el-row v-show="this.isShow == false">
                        <el-col :span="24"><div class="warnTitle">定期更换密码可以让你的账户更安全。</div></el-col>
                        <el-col :span="24"><div class="warnTitle">建议密码采用字母和数字混合密码只能6位。</div></el-col>
                      </el-row>
                      <el-row v-show="this.isShow == true">
                         <el-col :span="24"><div class="warnTitle">更换手机号后原手机号不可登录</div></el-col>
                      </el-row>
                  </el-col>
                </el-row>
              </div>
               <el-form ref="resetPwd" :model="formData" :rules="rules" label-width="200px" id="checkpwd" v-show="this.isShow == 0">
                <el-form-item label="原密码：" prop="password">
                 <el-input class="remarks"  type="text" v-model="formData.password" ></el-input>
                </el-form-item>
                <el-form-item label="新登录密码：" prop="password">
                 <el-input class="remarks"  type="password" v-model="formData.newCheckPwd" ></el-input>
                </el-form-item>
                <el-form-item label="确认新登录密码：" prop="newCheckPwd">
                  <el-input class="remarks"  type="password" v-model="formData.chomCheckPwd" ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="nextBtn" size="medium" @click="submitForm('resetPwd')">确定</el-button>
                </el-form-item>
              </el-form>
              <el-form ref="resetTel" :model="TelformData" :rules="telRules" id="reset-tel" v-show="this.isShow == 1">
                <el-form-item prop="mobile">
                 <el-input class="remarks" v-model="TelformData.mobile" placeholder="请输入新绑定的手机号"></el-input>
                </el-form-item>
                <el-form-item  prop="VCode" class="code">
                  <el-input v-model="TelformData.VCode" placeholder="请输入验证码">
                    <template slot="append">
                      <el-button type="text" @click="getVerifiCode" :disabled="telIsDisable">{{this.codeText}}</el-button>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="checkBtn" size="medium" @click="submitForm('resetTel')">确定</el-button>
                </el-form-item>
              </el-form>

            </div>
          </el-col>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import Refresh from "../common/Refresh";

export default {
  name: "ResetPwd",
  components: {
    PageHeaderLayout,
    Refresh
  },
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/.test(value)) {
    //     callback()
    //   } else {
    //     callback(new Error('密码只能是字母和数字组合长度为6-12'))
    //   }
    // }
    // var validateCheckPass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请再次输入密码'));
    //   } else if (value !== this.formData.password) {
    //     callback(new Error('两次输入密码不一致!'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      codeText:'获取验证码',
      telIsDisable: false,
      isShow: true,
      formData: {
        password: "",
        newCheckPwd: "",
		chomCheckPwd:""
      },
      TelformData: {
        mobile: "",
        VCode: ""
      },
      rules: {
        // password: [
        //   { required: true, message: '请输入新登录密码', trigger: 'blur' },
        //   { validator: validatePass },
        //   { min: 6, max: 12,message: '长度在6-12个以内字符', trigger: 'blur' }
        // ],
        // newCheckPwd: [
        //   { required: true, message: "请输入再次新登录密码", trigger: "blur" },
        //   {
        //     validator: validateCheckPass
        //   }
        // ]
      },
      telRules: {
        mobile: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          {
            validator: function(rule, value, callback) {
              if (!/^([1-9]\d*)?$/.test(value)) {
                callback(new Error('手机号只能输入数字'))
              } else {
                callback()
              }
            }
          },
          { min: 11, message: '请输入11位手机号' }
        ],
        VCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            // validator: function(rule, value, callback) {

            // }
          }
        ],
      }
    };
  },
  created() {
    this.isShow = this.$route.query.isTel
  },
  methods: {
    //获取验证码
    getVerifiCode() {
      if(!this.TelformData.mobile) {
        this.$message.error('请先输入手机号')
      }else {
        this.verificationCode()
      }
    },
     //获取验证码
    async verificationCode(){
      let verCode  = await this.$api.getCode({
        mobile: this.TelformData.mobile
      })
      if(verCode) {
        // eslint-disable-next-line
        MtaH5.clickStat("sendsmscode", {
          code: verCode
        })
        this.countDown(60)
      }
    },
    // 倒计时方法
    countDown (time) {
      if (time === 0) {
        this.telIsDisable = false
        this.codeText = "获取验证码"
        return
      } else {
        this.telIsDisable = true
        this.codeText = '重新发送(' + time + ')'
        time--
      }
      setTimeout(()=> {
        this.countDown(time)
      }, 1000)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(formName=='resetPwd') {
            this.formPwdSubmit();
          }else {
            this.formMobileSubmit()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改密码的实际方法
    async formPwdSubmit() {
      let id = JSON.parse(this.$storage.get('user_info')).id
      let args = {password:this.formData.password,newPassword: this.formData.newCheckPwd,confirmPassword:this.formData.chomCheckPwd}
      let result = await this.$api.changePassword(id, args)
      this.$nextTick(async () => {
        if (result) {
          this.$message.success('修改成功')
          this.mxLogout()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    //修改手机号的实际方法
    async formMobileSubmit() {
      let id = JSON.parse(this.$storage.get('user_info')).id
      let args  = {
        mobile: this.TelformData.mobile
      }
      let result = await this.$api.changeMobile(id, args)
      this.$nextTick(async () => {
        if (result) {
          this.$message.success('修改成功')
          this.mxLogout()
        } else {
          this.$message.error('修改失败')
        }
      })
    }

}
};
</script>
<style lang="stylus" scoped>
  .content
    margin-top: 55px
  .title
    margin-left: 150px
  #checkpwd
    width: 500px
    margin-left: 135px
    margin-top: 40px
  #reset-tel
    width: 450px
    margin-left: 205px
    margin-top: 40px
  .nextBtn,
  .checkBtn
    margin-top: 20px
    text-align: center
  /deep/.el-form-item__label
    font-size: 18px
    color: rgba(16, 16, 16, 1)
  .warnTitle
    height: 33px
    line-height: 33px
    color: rgba(16, 16, 16, 1)
    font-size: 18px
    text-align: left
    font-family: SourceHanSansSC-regular
  .warn
    font-size: 40px
    color: rgba(255, 149, 2, 1);
  /deep/.code .el-input-group__append
    width: 100px
    text-align: center

</style>